"use strict";

var numeral = require("numeral");
import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("numberUtils", function () {
  var numberUtils = {
    /**
     * Clean given number string
     */
    cleanNumberString: function cleanNumberString(str) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return str // TODO : use decimalDelimiterKeys & automatize regexps
      .replace(/[.]/g, ",").replace(/[^\d,.-]/g, "");
    },
    parseNumber: function parseNumber(str) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cleaned = numberUtils.cleanNumberString(str, options);
      return numeral().unformat(cleaned);
    }
  };
  return numberUtils;
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/numberUtils.js
// module id = 2759
// module chunks = 13